import {
  GET_BOOKS,
} from 'constants/books';

export default (state = [], action) => {
    switch (action.type) {
    case `${GET_BOOKS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
